import { cn as e } from "../lib/utils.js";
import { COMPONENT_SIZES as t, formControlSizeClasses as n } from "../shared/component-sizes.js";
import { applyPasswordManagerAutofillDefaults as r } from "../shared/password-manager-autofill.js";
import * as i from "react";
import { cva as a } from "class-variance-authority";
import { jsx as o } from "react/jsx-runtime";
//#region src/shadcn/input.tsx
var s = a("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
	variants: { size: {
		default: `${n("default")} py-2 md:text-sm`,
		sm: `${n("sm")} py-1`,
		lg: `${t.lg.height} ${t.lg.paddingX} py-2 ${t.lg.textSize}`
	} },
	defaultVariants: { size: "default" }
}), c = i.forwardRef(({ className: t, type: n, size: i, allowPasswordManagerAutofill: a, ...c }, l) => {
	let u = r({
		allowPasswordManagerAutofill: a,
		...c
	});
	return /* @__PURE__ */ o("input", {
		type: n,
		"data-slot": "input",
		className: e(s({
			size: i,
			className: t
		})),
		ref: l,
		...u
	});
});
c.displayName = "Input";
//#endregion
export { c as Input, s as inputVariants };
